import React from 'react'
import BSForm from 'react-bootstrap/Form';
import BSFormControl from 'react-bootstrap/FormControl';
import InputField, { FeedbackInput } from './InputField';
import { ValidationError } from '@hookstate/validation'

interface DateTimeFieldProps extends FeedbackInput {
    validate?: () => ValidationError[]
}

const CrossFieldValidationI: React.FC<DateTimeFieldProps> = ({ error }) => {

    return (
        <BSForm.Group >
            <BSFormControl.Feedback type="invalid" style={{ display: !!error ? 'block' : 'none' }}>{error}</BSFormControl.Feedback>
        </BSForm.Group>
    )
}

const CrossFieldValidation = (props: any) => <InputField component={CrossFieldValidationI} {...props} />
export default CrossFieldValidation

